import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { useI18n } from 'next-localization';
import styles from './styles/Dropdown.module.scss';
import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';

type Props = {
  children: React.ReactNode;
  outsideClick: () => void;
  handleEnterClick: () => void;
  cancelEvent: () => void;
  confirmEvent: () => void;
  loading: boolean;
  slots?: React.ReactNode;
};

const Dropdown = ({
  children,
  outsideClick,
  handleEnterClick,
  loading,
  cancelEvent,
  confirmEvent,
  slots,
}: Props) => {
  const { t } = useI18n();
  const [height, setHeight] = useState(0);

  const toggleDropdown = () => {
    setHeight(height === 0 ? 'auto' : 0);
  };

  return (
    <div className="relative">
      <div
        className="d-flex expandable collapsed"
        tabIndex="0"
        onClick={toggleDropdown}
        onKeyDown={(e) => {
          if (e.code === 'Enter') {
            handleEnterClick();
            toggleDropdown();
          }
          if (e.code === 'Escape') {
            outsideClick();
            toggleDropdown();
          }
        }}
      >
        {slots.triggeredArea}
      </div>
      <AnimateHeight height={height} duration={200}>
        <div className={`${styles.dropdown} ${styles.absolute}`}>
          {children}
          <div
            className={`${styles['filter-dropdown-nav']} d-flex align-items-center justify-content-between`}
          >
            <AbrdnButton
              buttonType="secondary"
              className={loading ? 'disabled' : ''}
              onClick={() => {
                if (!loading) {
                  cancelEvent();
                }
              }}
            >
              <span>{t('clear')}</span>
            </AbrdnButton>
            <AbrdnButton
              buttonType="primary"
              className={loading ? 'disabled' : ''}
              onClick={() => {
                if (!loading) {
                  confirmEvent();
                }
              }}
            >
              <span>{t('apply')}</span>
            </AbrdnButton>
          </div>
        </div>
      </AnimateHeight>
    </div>
  );
};

export default Dropdown;
